import { Link } from '@mui/material';
import type { GridColDef } from '@mui/x-data-grid';

import { dateUtils } from '@/utils/date';
import { t } from '@/utils/lang';

export const columns = (): GridColDef[] => [
    {
        field: 'name',
        headerName: t('Tên vai trò'),
        editable: false,
        sortable: false,
        minWidth: 250,
        renderCell: (params: any) => {
            return params.row.name ? <span>{params.row.name}</span> : '';
        },
    },
    {
        field: 'role',
        headerName: t('Nhóm'),
        editable: false,
        sortable: false,
        minWidth: 350,
        flex: 1,
        renderCell: (params: any) => {
            return params.row.role ? <span>{params.row.role}</span> : '';
        },
    },
    {
        field: 'createdDate',
        headerName: t('Ngày tạo'),
        editable: false,
        sortable: true,
        minWidth: 250,
        flex: 1,
        sortingOrder: ['asc', 'desc'],
        renderCell: (params: any) => {
            return dateUtils.getDateTimeLocal(params.row.createdDate);
        },
    },
    {
        field: 'viewUsers',
        headerName: '',
        editable: false,
        sortable: false,
        minWidth: 200,
        flex: 1,
        align: 'center',
        renderCell: (params: any) => {
            return (
                <Link
                    component='span'
                    underline='hover'
                    variant='body2'
                    onClick={() => {}}
                >
                    {t('Xem người dùng', 'RoleList')}
                </Link>
            );
        },
    },
];
